<template>
  <div>
    <van-skeleton title animate :row="12" round="true" :loading="loading_ske">
      <div class="titles use1">
        <p>用户列表</p>
        <el-select v-model="isface" class="djs02-001" filterable placeholder="请选择是否录入人脸" @change="choseIsface">
          <el-option
            v-for="(item,index) in isfaceList"
            :key="'zuz'+index"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="usr2">
          <el-button type="primary" size="small usr3" icon="el-icon-circle-plus-outline" @click="toAdu">账号创建</el-button>
        </div>
<!--        <Button type="info" shape="circle" class="role01" size="small" icon="ios-add" @click="del">添加</Button>-->
      </div>
      <Table border ref="selection" :columns="columns7" :data="data6" :loading="loading"></Table>
      <div class="role02">
        <Page :total="total" @on-change="nextPage"/>
      </div>
    </van-skeleton>

    <xc-model :loading="aduModel" title="账号创建" :is_buttom="false" @cancel="adu_cancel">
      <div slot="mbody">
        <div class="djt17">
          <div class="djt18">
            <div class="djt19">编号：</div>
            <input v-model="aduser.code" type="text" placeholder="请输入员工编号" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">姓名：</div>
            <input v-model="aduser.name" type="text" placeholder="请输入姓名" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">账号：</div>
            <input v-model="aduser.acc" type="text" maxlength="11" placeholder="请输入账号" class="djt20">
          </div>
          <div class="djt21">
            <el-button style="line-height: 0" class="djt22" :loading="aduLoading" @click="aduShur">确认</el-button>
            <div class="djt22" style="margin-left: 50px" @click="adu_cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>

    <xc-model :loading="xgsModel" title="修改手机号码" :is_buttom="false" @cancel="xgs_cancel">
      <div slot="mbody">
        <div class="djt17">
          <div class="djt18">
            <div class="djt19">手机号：</div>
            <input v-model="xguser.phone" type="text" maxlength="11" placeholder="请输入手机号码" class="djt20">
          </div>
          <div class="djt18" style="margin-top:20px;margin-left: 10px;">
            <div class="djt19">编号：</div>
            <input v-model="xguser.code" type="text" maxlength="11" placeholder="请输入员工编码" class="djt20">
          </div>
          <div class="djt18" style="margin-top:20px;margin-left: 10px;">
            <div class="djt19">密码：</div>
            <input v-model="xguser.pwd" type="text" maxlength="11" placeholder="请输入密码" class="djt20">
          </div>
          <div class="djt21">
            <el-button style="line-height: 0" class="djt22" :loading="aduLoading" @click="xgsShur">确认</el-button>
            <div class="djt22" style="margin-left: 50px" @click="xgs_cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from '@/api/user';
  import https from '@/api/schemaSequence';
  import util from '@/util/util';
  export default {
    name: "userList",
    data() {
      return {
        isfaceList:[
          {id:'1',name:'已录入人脸'},
          {id:'0',name:'未录入人脸'},
        ],
        xgsModel:false,
        aduModel:false,
        columns7: [
          {
            title: '名称',
            key: 'name',
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'person'
                  }
                }),
                h('strong', params.row.name)
              ]);
            }
          },
          {
            title: '手机号码',
            key: 'mobile'
          },
          {
            title: '注册时间',
            key: 'ctime'
          },
          {
            title: '部门',
            key: 'orgName'
          },
          {
            title: '是否录入人脸',
            key: 'isface'
          },
          {
            title: '操作',
            key: 'action',
            width: 300,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                    icon:'md-person-add'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, '用户详情'),
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                    icon:'ios-create-outline'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.toEdit(params.index)
                    }
                  }
                }, '修改手机号'),
              ]);
            }
          }
        ],
        data6: [],
        loading_ske:true,     //骨架屏显示
        page:1,               //页数
        pageSize:10,          //显示条数
        total:0,              //列表总数
        loading:false,        //是否加载
        aduser:{
          name:'',
          acc:'',
          code:''
        },
        xguser:{
          phone:'',
          companyId:'',
          code:'',
          pwd:''
        },
        aduLoading:false,
        lsItem:[],
        isface:''
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      var me = this;
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = {
        companyId:'',
        userName:'',
        mobile:user.mobile,
        sign:user.sign,
        page:me.page,
        pageSize:me.pageSize,
        isface:me.isface
      }
      if (user.companyId == 1) {
        data['companyId'] = '';
      } else {
        data['companyId'] = user.companyId;
      }
      https.userlistbycode(data).then(res => {
        console.log(res);
        me.data6 = res.data.dataList;
        me.total = res.data.totalNum;
        me.loading_ske = false;
      })
    },
    methods: {
      choseIsface(e){
        me.loading = true;
        me.isface = e;
        let data = {
          companyId:'',
          userName:'',
          mobile:user.mobile,
          sign:user.sign,
          page:me.page,
          pageSize:me.pageSize,
          isface:me.isface
        }
        if (user.companyId == 1) {
          data['companyId'] = '';
        } else {
          data['companyId'] = user.companyId;
        }
        https.userlistbycode(data).then(res => {
          me.data6 = res.data.dataList;
          me.total = res.data.totalNum;
          me.loading = false;
        })
      },
      toEdit(index){/*前往修改手机号*/
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'用户管理','修改员工信息');
        if (is_auth == true) {
          me.xgsModel = true;
          me.lsItem = me.data6[index];
          me.xguser.phone = me.data6[index].mobile;
          me.xguser.companyId = me.data6[index].companyid;
          me.xguser.code = me.data6[index].code;
          me.xguser.id = me.data6[index].id;
          console.log(me.xguser.companyId,"世界真大")
        } else {
          me.$message.error('暂无权限');
          return false;
        }
      },
      xgsShur(){/*确定修改信息*/
        if (me.xguser.phone == '') {
          me.$message.error('请输入手机号码');
          return false;
        }
        if (!util.is_num(me.xguser.phone) || me.xguser.phone.length != 11) {
          me.$message.error('手机号码为11位数字');
          return false;
        }
        if (me.xguser.companyId == '') {
          me.$message.error('请输入编号');
          return false;
        }
        // if (me.xguser.pwd == '') {
        //   me.$message.error('请输入密码');
        //   return false;
        // }
        me.aduLoading = true;
        let data = {
          id:me.lsItem.id,
          mobile:me.xguser.phone,
          pwd:me.xguser.pwd,
          companyId:user.companyId,
          code:me.xguser.code,
        }
        https.updateuserinfo(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                companyId:'',
                userName:'',
                mobile:user.mobile,
                sign:user.sign,
                page:me.page,
                pageSize:me.pageSize,
                isface:me.isface
              }
              if (user.companyId == 1) {
                data['companyId'] = '';
              } else {
                data['companyId'] = user.companyId;
              }
              https.userlistbycode(data).then(res => {
                console.log(res);
                me.data6 = res.data.dataList;
                me.total = res.data.totalNum;
                me.$message.success('已修改手机号码');
                me.xgsModel = false;
                me.xguser.phone = '';
                me.xguser.pwd = '';
                me.aduLoading = false;
              })
              break;
            case "1001":
              me.aduLoading = false;
              me.$message.error('编码重复');
              break;
              case "1004":
              me.aduLoading = false;
              me.$message.error('密码与之前密码重复');
              break;
              case "1111":
              me.aduLoading = false;
              me.$message.error('修改失败');
              break;
          }
        })
      },
      xgs_cancel(){/*修改信息返回*/
        me.xgsModel = false;
        me.xguser.phone = '';
      },
      toAdu(){/*前往账号创建*/
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'用户管理','账号创建');
        if (is_auth == true) {
          me.aduModel = true;
        } else {
          me.$message.error('暂无权限');
          return false;
        }
      },
      aduShur(){/*确定创建用户*/
        if (me.aduser.code == '') {
          me.$message.error('请输入员工编号');
          return false;
        }
        if (me.aduser.name == '') {
          me.$message.error('请输入姓名');
          return false;
        }
        if (me.aduser.acc == '') {
          me.$message.error('请输入账号');
          return false;
        }
        if (!util.is_num(me.aduser.acc)) {
          me.$message.error('账号为11位数字');
          return false;
        }
        me.aduLoading = true;
        let data = {
          mobile:me.aduser.acc,
          userNanme:me.aduser.name,
          code:me.aduser.code,
          passWord:123456,
          userId:user.userId,
          companyName:user.companyName,
          companyId:user.companyId,
        }
        https.adduserbycode(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                mobile:user.mobile,
                sign:user.sign,
                page:me.page,
                pageSize:me.pageSize
              }
              if (user.companyId == 1) {
                data['companyId'] = '';
              } else {
                data['companyId'] = user.companyId;
              }
              httpUser.userList(data).then(res => {
                console.log(res);
                me.data6 = res.data.dataList;
                me.total = res.data.totalNum;
                me.$message.success('已分配账号');
                me.aduModel = false;
                me.aduser.name = '';
                me.aduser.acc = '';
                me.aduser.code = '';
                me.aduLoading = false;
              })
              break;
            case "1000":
              me.aduLoading = false;
              me.$message.error('用户已经在工业云平台存在');
              break;
            case "1111":
              me.aduLoading = false;
              me.$message.error('添加失败');
              break;
          }
        })
      },
      adu_cancel(){/*创建用户返回*/
        me.aduModel = false;
        me.aduLoading = false;
      },
      show(index) {
        this.$Modal.info({
          title: '用户详情',
          content: `姓名：${this.data6[index].name}<br>年龄：${this.data6[index].age}<br>地址：${this.data6[index].address}`
        })
      },
      remove(index) {
        this.data6.splice(index, 1);
      },
      edit(index) {//编辑用户
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'用户管理','用户详情');
        if (is_auth == true) {
          me.$router.push({path:'/user/userInfo',query:{userId:me.data6[index].id}})
        } else {
          me.$message.error('暂无权限');
          return false;
        }
      },
      del() {//删除用户
        var me = this;
        me.$message.error('暂未选择数据');
      },
      nextPage(e){//下一页
        var me = this;
        me.loading = true;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          companyId:'',
          userName:'',
          mobile:user.mobile,
          sign:user.sign,
          page:e,
          pageSize:me.pageSize,
          isface:me.isface
        }
        if (user.companyId == 1) {
          data['companyId'] = '';
        } else {
          data['companyId'] = user.companyId;
        }
        https.userlistbycode(data).then(res => {
          console.log(res);
          me.data6 = res.data.dataList;
          me.loading = false;
        })
      }
    }
  }
</script>

<style scoped>
@import "user.css";
</style>